import React from "react";

const Stat_Interquartile_Range = () => {
  return (
    <div>
      <h1>Stat Interquartile Range</h1>
    </div>
  );
};

export default Stat_Interquartile_Range;
